import lodash from 'lodash';
import Select from 'react-select';
import styles from '../containers/Events.scss';
import DateTimePicker from 'common/components/DateTime/DateTimePicker';
import MultiSelectCheckbox from 'components/common/MultiSelectCheckbox/MultiSelectCheckbox';
import RadioList from '../../../components/common/RadioList/RadioList';
import Input from 'components/common/Input/FormInput';
import globalStyles from 'styles/global.scss';

export const EventDetailsHeader = ({ historyButton, eventType }) => (
    <header className={styles.eventHistoryEntryHeaderHeader} data-cy="EventDetailsHeader">
        <span className={styles.eventHistoryEntryCreatedy}>
            <p className={styles.eventTypeValue} data-cy="EventDetailsHeader-eventType">{eventType}</p>
        </span>
        <span className={styles.eventHistoryEntryTimestamp} data-cy="EventDetailsHeader-historyButton">
            {historyButton}
        </span>
    </header>
);

export const RequiresSignatureCheckbox = ({requiresSignature, onToggleCheckbox}) => {
    return (
        <div className={`${styles.requiresSignatureParent}`} data-cy="RequiresSignatureCheckbox">
            <div className={styles.requiresSignatureHeader}>
                <input id="requireSignatureCheckbox" data-cy="RequiresSignatureCheckboxInput" className={styles.requiresSignatureCheckbox} type="checkbox" checked={requiresSignature} onChange={onToggleCheckbox} />
                <label className={styles.requiresSignatureLabel} htmlFor="requireSignatureCheckbox">Requires Signature</label>
            </div>
        </div>
    );
};

export const DetailSelect = ({label, placeholder, value, items=[], onSelect}) => {
    const selectValue = lodash.find(items, { value });

    return (
        <div className={`${styles.detailParent}`} data-cy="DetailSelect">
            <div className={styles.detailSelectHeader}>
                <label className={styles.detailSelectTitle} data-cy="DetailSelect-label">{label}</label>

                <Select value={selectValue}
                    options={items}
                    className={styles.select}
                    isClearable={true}
                    onChange={selection => selection ? onSelect(selection.value) : onSelect(null)}
                    placeholder={placeholder}
                    data-cy="DetailSelect-Select"/>
            </div>
        </div>
    );
};

export const DetailDatePicker = ({label, value, onSelect}) => {
    return (
        <div className={`${styles.detailParent}`} data-cy="DetailDatePicker">
            <div className={styles.detailSelectHeader}>
                <label className={styles.detailSelectTitle} data-cy="DetailDatePicker-label">{label}</label>
                <DateTimePicker
                    value={value}
                    onChange={onSelect}
                    time={false}
                    placeholder={'Select a Date'}
                    noTimezone={true}
                />
            </div>
        </div>
    );
};

export const DetailInput = ({title, placeholder, type, value, required, onChange, isValid, maxLength}) => {
    const validator = isValid ? () => isValid() : () => true;
    return (
        <div className={`${styles.detailParent}`} data-cy="DetailInput">
            <Input
                title={title}
                placeholder={placeholder}
                type={type}
                value={value}
                isValid={validator}
                required={required}
                onBlur={() => {}}
                onChange={onChange}
                maxLength={maxLength}
                data-cy="DetailInput-Input"
            />
        </div>
    );
};

export const DetailCheckbox = ({label, checked, onChange, id}) => {
    return (
        <div className={styles.detailParent} data-cy="DetailCheckbox">
            <input
                id={id}
                name={id}
                type="checkbox"
                checked={!!checked}
                onChange={e => onChange && onChange(e.target.checked)}
                data-cy="DetailCheckbox-Input"
            />
            <label htmlFor={id} className={globalStyles.ml5}>{label}</label>
        </div>
    );
};

export const DetailRadioList = ({name, title, options, onSelect, value, disableOtherOption}) => {
    return (
        <div className={`${styles.detailParent}`}  data-cy="DetailRadioList">
            <RadioList
                name={name}
                title={title}
                options={options}
                value={value}
                onSelect={onSelect}
                disableOtherOption={disableOtherOption}
                data-cy="DetailRadioList-list"
            />
        </div>
    );
};

export const UserMultiSelect = ({setMultiselectValue, multiselectUsers, details, existingPendingSigs = [], onRemove}) => {
    const { signatureRequests: inboundStateSignatures = [] } = details;
    const stateSigRequestIds = lodash.map(inboundStateSignatures, (sigRequest) => {
        const requestedFromId = lodash.get(sigRequest, 'id', null);
        if (!lodash.isNil(requestedFromId)) {
            return requestedFromId;
        }
    });
    const existingPendingSigRequestIds = existingPendingSigs.reduce((acc, sig) => {
        return acc.concat(sig.id);
    }, []);
    const stateSelectedUsers = inboundStateSignatures.reduce((acc, sig) => {
        const isReadOnlySignature = lodash.includes(existingPendingSigRequestIds, sig.id);
        if (!isReadOnlySignature) {
            return acc.concat(sig);
        }
        return acc;
    }, []);
    const finalSelected = existingPendingSigs.reduce((acc, pendingSig) => {
        const pendingInState = lodash.includes(stateSigRequestIds, pendingSig.id);
        if (pendingInState) {
            return acc;
        }
        return acc.concat(pendingSig);
    }, inboundStateSignatures);
    return (
        <div className={`${styles.detailParent}`} data-cy="UserMultiSelect">
            <div className={styles.detailSelectHeader}>
                <MultiSelectCheckbox
                    onChanged={setMultiselectValue}
                    options={multiselectUsers}
                    selectedOptions={stateSelectedUsers}
                    placeholder={'Select Signees'}
                    searchBarPlaceholder={'Search for Users'}
                    isSelectAllRequired={false}
                    data-cy="UserMultiSelect-checkbox"
                />
                <SelectedMultiselectItems items={finalSelected} onRemove={onRemove}/>
            </div>
        </div>
    );

};

const SelectedMultiselectItems = ({items, onRemove}) => {
    const selectedItems = items.map((item, index) => {
        if(item.status === 'COMPLETE'){
            return null;
        }
        return (
            <li key={index} className={styles.selectedItem} data-cy={'SelectedMultiselectItems-' + index}>
                <p className={styles.selectedItemText} data-cy={'SelectedMultiselectItems-label-' + index}>{item.label}</p>
                <i className={styles.closeIcon} onClick={() => onRemove(item)} data-cy={'SelectedMultiselectItems-Btn-' + index}>close</i>
            </li>
        );
    });

    return (
        <ul className={styles.selectedItemsList} data-cy="SelectedMultiselectItems-ul">
            {selectedItems}
        </ul>
    );
};
